import { Injector } from "@angular/core";
export const AppConstants = {
  urls: {
    ut: "https://dirapi.edap.com.pk/uateu/api/",
    api: "https://dirapi.edap.com.pk/uateu/api/",
    reportUrl: "https://diruatreport.edap.com.pk/WebForms/DevExReportViewer.aspx",
    externalURL: "https://live.edap.com.pk/",
    videourl : "https://tutorials.edap.com.pk/"
  },
  settings: {
    dateFormatforString: "DD-MMM-YYYY",
    timeFormatforString: "hh:mm:ss A",
    dateformat: "dd-MMM-yyyy",
    timeFormat: "HH:mm:ss",
    dateAndTime: "YYYY-MM-DDTHH:mm",
    dateFormat: "dd-MMM-yyyy",
    monthDateYear: "MM/DD/YYYY",
    timeFormatTile: "hh:mm A",
    date: "MMM d, y",
    appCode: "SB",
    instanceid: 1,
    instancecode: "UT001",
    clientid: 154,
  },
  policy: {
    dateFormat: "",
    timeFormat: "",
    gridpagging: "15",
    defaultcityid: 0,
    defaultctryid: 0,
    defaultstateid: 0,
  },
  injector: <Injector>{},
  /////  Etisalcom  ////////
  ourpartner: {
    name: "",
  }
};